module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (180).b06f9e73.jpg";